"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'Find Data Link',
    description: 'Find a link between records in your app and external app',
});
//# sourceMappingURL=find-data-link.js.map